import React from 'react';
import { CheckIcon, PickaxeIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-slate-800 bg-slate-900 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-61" data-mp="15ddkvgp2i9mp">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-62" data-mp="1jclja7depdpu">
        <h2 id="final-title" className="text-balance text-3xl font-bold tracking-tight text-white sm:text-4xl" data-id="element-63" data-mp="1jb23ehvnx4ol">
          <span className="inline-flex items-center gap-2" data-id="element-64" data-mp="1ec7jtdpvfc3f">
            <PickaxeIcon className="h-8 w-8 shrink-0 text-orange-400" aria-hidden="true" data-id="element-65" data-mp="1t1n1833ii56g" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-semibold text-amber-400 sm:text-2xl" data-id="element-66" data-mp="1o5y7whi35kil">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-slate-300" data-id="element-67" data-mp="1x51onets5ntx">
          Created for underground mining technicians, supervisors and engineers worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" checkout arrow className="mt-8 w-full sm:w-auto" data-id="element-68" data-mp="s4fog7xgmj8d">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-slate-300" data-id="element-69" data-mp="122vdm5cxfif8">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-70" data-mp="1658iysnrhebh">
              <CheckIcon className="h-4 w-4 text-orange-400" aria-hidden="true" data-id="element-71" data-mp="1b3jquxuhxer2" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}